import { SignUpSettingsResponse, SMS_VERIFIED_METHOD_TYPES } from 'src/types/register';

export type SmsPreVerificationMethod = 'KMC' | 'TSP' | 'NONE';

const isValidRedirectUrl = (redirectUrl: unknown): redirectUrl is string => {
  return typeof redirectUrl === 'string' && redirectUrl.trim().length > 0;
};

export const getKmcRedirectUrl = (settings?: SignUpSettingsResponse | null): string | undefined => {
  const redirectUrl = settings?.smsVerifiedSettings?.kmcInfo?.redirectUrl;

  return isValidRedirectUrl(redirectUrl) ? redirectUrl : undefined;
};

// signup-settings로부터 인증 수단을 계산하는 순수 함수.
// UI는 이 값을 직접 쓰지 말고, freezeSmsPreVerificationMethodAtom으로
// smsPreVerificationMethodAtom에 고정한 뒤 그 atom을 읽는다.
export const getSmsPreVerificationMethod = (
  settings?: SignUpSettingsResponse | null
): SmsPreVerificationMethod => {
  const smsVerifiedSettings = settings?.smsVerifiedSettings;

  if (smsVerifiedSettings?.preVerification !== true) {
    return 'NONE';
  }

  if (smsVerifiedSettings.mainSms === SMS_VERIFIED_METHOD_TYPES.KMC) {
    if (!getKmcRedirectUrl(settings)) {
      throw new Error('KMC redirectUrl is required when mainSms is KMC');
    }

    return 'KMC';
  }

  if (smsVerifiedSettings.mainSms === SMS_VERIFIED_METHOD_TYPES.TSP) {
    return 'TSP';
  }

  throw new Error(`Unsupported mainSms: ${smsVerifiedSettings.mainSms}`);
};

export const getSmsPreVerificationMethodFromLoadable = (
  signUpSettingsLoadable:
    | { state: 'loading' }
    | { state: 'hasError' }
    | { state: 'hasData'; data: SignUpSettingsResponse },
  fallback: SmsPreVerificationMethod
): SmsPreVerificationMethod => {
  return signUpSettingsLoadable.state === 'hasData'
    ? getSmsPreVerificationMethod(signUpSettingsLoadable.data)
    : fallback;
};

// Apple 회원가입은 enabledSignupWithApple === true일 때만 KMC를 허용한다.
// freezeSmsPreVerificationMethodAtom이 Apple loginType과 함께 이 값을 보고 KMC 고정을 막는다.
export const isAppleSignupKmcEnabled = (settings?: SignUpSettingsResponse | null): boolean => {
  return settings?.smsVerifiedSettings?.enabledSignupWithApple === true;
};
